import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";
import type { DevelopmentFaq } from "@/services/developmentFaqService";

type ResortFaqSectionProps = {
  resortName: string;
  items: DevelopmentFaq[];
};

const ResortFaqSection = ({ resortName, items }: ResortFaqSectionProps) => {
  if (items.length === 0) return null;

  return (
    <section
      id="faq"
      className="border-t bg-muted/20 py-20 sm:py-24"
      aria-labelledby="resort-faq-heading"
    >
      <div className="container mx-auto px-4 sm:px-6 max-w-4xl">
        <div className="text-center mb-10">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-primary mb-3 flex items-center justify-center gap-2">
            <HelpCircle className="h-4 w-4" aria-hidden />
            Dúvidas frequentes
          </p>
          <h2
            id="resort-faq-heading"
            className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground"
          >
            Perguntas sobre o {resortName}
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {items.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`faq-${faq.id}`}
              className="rounded-xl border border-border bg-card px-5 shadow-sm"
            >
              <AccordionTrigger className="text-left text-base font-medium hover:no-underline py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="pb-4">
                <div
                  className="prose prose-sm max-w-none text-muted-foreground leading-relaxed [&_a]:text-primary [&_a]:underline [&_img]:my-3 [&_img]:max-w-full [&_img]:rounded-lg [&_p]:mb-2 [&_ul]:list-disc [&_ul]:pl-5"
                  dangerouslySetInnerHTML={{ __html: faq.answer_html }}
                />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default ResortFaqSection;
